import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import SubLineasCreate from "./SubLineasCreate";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import Swal from "sweetalert2";

function ListadoSubLineas() {
  const { user } = useContext(AuthContext);
  const URL_SUB_LINEAS = process.env.REACT_APP_URL_SUB_LINEAS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [subLineas, setSubLineas] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [idEdit, setIdEdit] = useState();
  const toggle = () => setModal(!modal);

  useEffect(() => {
    axios
      .get(URL_SUB_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => setSubLineas(response.data))
      .catch((err) => console.log(err));

    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setLineas(res.data))
      .catch((err) => console.log(err));
  }, []);

  function editSubLinea(event) {
    event.preventDefault();
    const URL_EDIT = `${URL_SUB_LINEAS}/${idEdit}`;
    axios
      .patch(
        URL_EDIT,
        { name, lineas: selectedLinea },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Editar SubCategoria", detalle: name, user: user.id },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(id, nm, lineaId) {
    setName(nm);
    setSelectedLinea(lineaId || "");
    setIdEdit(id);
    toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        {user.menu_articulos ? (
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h3 align="center">SubCategorias</h3>
                  <Table
                    size="sm"
                    striped
                    borderless
                    className="table-responsive-xl"
                  >
                    <thead>
                      <tr>
                        <th className="tituloTabla">Nombre</th>
                        <th className="tituloTabla">Categoria</th>
                        <th className="tituloTabla">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subLineas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => (
                          <tr key={a._id}>
                            <td>{a.name}</td>
                            <td>{a.lineas?.[0]?.name || ""}</td>
                            <td>
                              <Button
                                color="info"
                                size="sm"
                                onClick={() =>
                                  jalaInfo(a._id, a.name, a.lineas?.[0]?._id)
                                }
                              >
                                <i className="far fa-edit"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <SubLineasCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar SubCategoria</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
          <Label className="mr-sm-2">Categoria</Label>
          <Input
            className="col-sm-12"
            type="select"
            value={selectedLinea}
            required
            onChange={(e) => setSelectedLinea(e.target.value)}
          >
            <option value="">Selecciona una Categoria</option>
            {lineas
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((a) => (
                <option key={a._id} value={a._id}>
                  {a.name}
                </option>
              ))}
          </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editSubLinea}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoSubLineas;
